import type {
  DefineComponent,
  ComponentOptionsMixin,
  ComputedOptions,
  MethodOptions,
  ExtractPropTypes
} from 'vue'

import FormTemplate from './questionaireTemplate.vue'
import InputBox from './formElements/fields/inputBox.vue'
import TextArea from './formElements/fields/textArea.vue'
import RadioButton from './formElements/fields/radioButton.vue'
import CheckBox from './formElements/fields/checkBox.vue'
import InfoBlock from './formElements/fields/infoBlock.vue'
import Calendar from './formElements/fields/calendar.vue'
import FileField from './formElements/fields/dropzone.vue'
import formResult from './formElements/formResult.vue'

type FlexibleComponent = DefineComponent<
  any,
  any,
  any,
  ComputedOptions,
  MethodOptions,
  ComponentOptionsMixin,
  ComponentOptionsMixin,
  any,
  string,
  any
>

type ComponentMap = Record<string, FlexibleComponent | undefined>

const COMPONENT_MAP: ComponentMap = {
  formTemplate: FormTemplate,
  textinput: InputBox,
  textarea: TextArea,
  radio: RadioButton,
  select: RadioButton,
  information: InfoBlock,
  datefield: Calendar,
  multiselect: CheckBox,
  filefield: FileField,
  formResult: formResult,
  emailinput: InputBox,
  phoneinput: InputBox,
  numberinput: InputBox,
  urlinput: InputBox,
  yesno: RadioButton
}

export function getComponent(type: string): FlexibleComponent | undefined {
  return COMPONENT_MAP[type]
}
